import styled, { css, keyframes } from 'styled-components';
import { colors } from '@ardoq/design-tokens';
import { aiGradientBackground } from '@ardoq/style-helpers';
import { IconSize } from './types';

const STAR_PATH =
  'M10.5508 12.3428V16.1992H8.58789V12.3428H10.5508ZM8.58789 12.3428H6.625V10.4141H8.58789V12.3428ZM12.5127 12.3428H10.5508V10.4141H12.5127V12.3428ZM8.58789 8.48535H6.625V10.4141H2.7002V8.48535H6.625V6.55664H8.58789V8.48535ZM16.2002 10.4141H12.5127V8.48535H16.2002V10.4141ZM12.5127 8.48535H10.5508V6.55664H12.5127V8.48535ZM10.5508 6.55762H8.58789V2.7002H10.5508V6.55762Z';

const encodedMaskSvg = encodeURIComponent(
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path fill="white" d="${STAR_PATH}"/></svg>`
);

const maskUrl = `url("data:image/svg+xml,${encodedMaskSvg}")`;

export const animateAiIconGradientFill = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

const maskStyles = css`
  mask-image: ${maskUrl};
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
  -webkit-mask-image: ${maskUrl};
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  -webkit-mask-size: contain;
`;

const StyledAiIconGradientAnimated = styled.span`
  position: relative;
  display: inline-block;
  width: ${IconSize.MEDIUM}px;
  height: ${IconSize.MEDIUM}px;
  color: ${colors.orange500};
  background-color: currentColor;
  ${maskStyles};
  pointer-events: none;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: ${aiGradientBackground};
    background-size: 300% 300%;
    opacity: 0;
    transition: opacity 0.2s ease-out;
    ${maskStyles};
    pointer-events: none;
  }
`;

const AiIconGradientAnimated = () => (
  <StyledAiIconGradientAnimated aria-hidden="true" />
);

const AI_ICON_GRADIENT_ANIMATED_SELECTOR =
  StyledAiIconGradientAnimated.toString();

export { AiIconGradientAnimated, AI_ICON_GRADIENT_ANIMATED_SELECTOR };
